module.exports = __webpack_public_path__ + "assets/plus_add_button-8fbe97.svg";